export const SOLVENCY_DECLARATION_ENDPOINTS = {
    solvencyDeclaration: '/solvency-declaration',
    current: '/solvency-declaration/my/current',
    questionnaire: '/solvency-declaration/questionnaire',
    submit: '/solvency-declaration/current/submit',
    resubmit: '/solvency-declaration/current/resubmit',
};
